/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { useContext, useEffect, useRef, useState } from 'react';
import { GContextTypes } from '../types';
import { GlobalContext } from '../contexts';
import {
  Box,
  Button,
  Checkbox,
  colors,
  FormControlLabel,
  Paper,
  Tab,
  Tabs,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from '@material-ui/core';
import PopupLayout from '../pages/main/PopupLayout';
import { Grid } from '@material-ui/core';
import { useLazyQuery, useMutation } from '@apollo/client';
import PopupTaskInvoice from './PopupTaskInvoice';
import { taskManamentTabs } from '../constants/rrule';
import EventsCustomer from '../Shared/EventsCustomer';
import InvoicesCustomer from '../Shared/InvoicesCustomer';
import ReceiptCustomer from '../Shared/ReceiptCustomer';
import {
  createExpenses,
  createFinance,
  createPurchaseOrder,
  getExpenses,
  getInvoices,
  getOperationItems,
  getProjects,
  getPurchaseOrders,
} from '../graphql';
import getTasks from '../graphql/query/getTasks';
import { useReactToPrint } from 'react-to-print';
import KaidsCustomer from '../Shared/KaidsCustomer';
import {
  useCustomers,
  useExpenseItems,
  useProducts,
  useServices,
  useTemplate,
} from '../hooks';
import useWindowDimensions from '../hooks/useWindowDimensions';
import useDepartments from '../hooks/useDepartments';
import useEmployees from '../hooks/useEmployees';
import useResourses from '../hooks/useResourses';
import { TabPanel, useStyles, a11yProps } from '../Shared/TabPanel';
import ReminderCustomer from '../Shared/ReminderCustomer';
import MainCustomer from '../Shared/MainCustomer';
import PopupReceipt from './PopupReceipt';
import getReceipts from '../graphql/query/getReceipts';
import ExpensesCustomer from '../Shared/ExpensesCustomer';
import PopupExpensesDoc from './PopupExpensesDoc';
import DateNavigatorReports from '../components/filters/DateNavigatorReports';
import InvoicesSupplier from '../Shared/InvoicesSupplier';
import PaymentSupplier from '../Shared/PaymentSupplier';
import ExpensesProdCustomer from '../Shared/ExpensesProdCustomer';
import getGereralCalculation from '../graphql/query/getGereralCalculation';
import { ContractPrint } from '../print';
import ExpensesItemsCustomer from '../Shared/ExpensesItemsCustomer';
import EventsItemsCustomer from '../Shared/EventsItemsCustomer';
import InvoicesItemsCustomer from '../Shared/InvoicesItemsCustomer';
import OrdersSupplier from '../Shared/OrdersSupplier';
import PopupPurchaseOrder from './PopupPurchaseOrder';
import PrintStockOrder from '../Shared/PrintStockOrder';
import { getDefaultTemplate } from '../common/helpers';
import usePrintTemplates from '../hooks/usePrintTemplates';
import useRentitems from '../hooks/useRentitems';
import { userroles } from '../common';
import { getContractRelatedItems } from '../graphql/query';

const PopupTaskView = ({
  open,
  onClose,
  item,
  tasks,
  isNew,
  theme,
  company,
  mstart,
  mend,
  stopTask,
  startTask,
}: any) => {
  const classes = useStyles();
  const [row, setRow] = useState(item);
  const [value, setValue] = React.useState(0);
  const [custvalue, setCustvalue] = useState(null);
  const [resovalue, setResovalue] = useState(null);
  const [openInvoice, setOpenInvoice] = useState(false);
  const [openReceipt, setOpenReceipt] = useState(false);
  const [openExpenses, setOpenExpenses] = useState(false);
  const [openOrder, setOpenOrder] = useState(false);

  const isTaskApproved =
    row?.approvalStatus === 1 ||
    row?.approvalStatus === 2 ||
    row?.approvalStatus === 3;

  const [calcs, setCalcs] = useState<any>(null);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [canProceedWithAdd, setCanProceedWithAdd] = useState(false);
  const [pendingExecute, setPendingExecute] = useState<any>(null);
  const [invoiceRows, setInvoiceRows] = useState([]);
  const [start, setStart]: any = useState(null);
  const [end, setEnd]: any = useState(null);
  const [currentViewName, setCurrentViewName] = useState('Month');
  const [currentDate, setCurrentDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [isTime, setIsTime] = useState(false);
  const [itemsList, setItemsList] = useState<any>([]);
  const [relatedItemsList, setRelatedItemsList] = useState<any>([]);
  const [closeloading, setCloseloading] = useState<any>(null);
  const currentViewNameChange = (e: any) => {
    setCurrentViewName(e.target.value);
  };
  const currentDateChange = (curDate: any) => {
    setCurrentDate(curDate);
  };

  const endDateChange = (curDate: any) => {
    setEndDate(curDate);
  };

  const { departments } = useDepartments();
  const { employees } = useEmployees();
  const { resourses } = useResourses();
  const { services } = useServices();
  const { products } = useProducts();
  const { customers } = useCustomers();
  const { expenseItems } = useExpenseItems();
  const { printtemplates } = usePrintTemplates();
  const { rentitems } = useRentitems();

  const { width, height } = useWindowDimensions();
  const { tempoptions, tempwords } = useTemplate();

  const refresQuery = {
    refetchQueries: [
      {
        query: getPurchaseOrders,
        variables: {
          start: start ? start.setHours(0, 0, 0, 0) : undefined,
          end: end ? end.setHours(23, 59, 59, 999) : undefined,
        },
      },
    ],
  };

  const [addPurchaseOrder] = useMutation(createPurchaseOrder, refresQuery);

  const [getItems, itemsData]: any = useLazyQuery(getOperationItems, {
    fetchPolicy: 'cache-and-network',
  });
  const [getRelatedItems, relateditemsData]: any = useLazyQuery(
    getContractRelatedItems,
    {
      fetchPolicy: 'cache-and-network',
    },
  );
  const [loadInvoices, opData]: any = useLazyQuery(getInvoices, {
    fetchPolicy: 'cache-and-network',
  });
  const handleChange = (_: any, newValue: any) => {
    setValue(newValue);
  };

  useEffect(() => {
    if (row && row._id) {
      const items = itemsData?.data?.['getOperationItems']?.data || [];
      if (items && items.length > 0) {
        const ids = items.map((it: any) => it.itemId);
        const servlist = [...rentitems, ...products, ...services].filter(
          (ser: any) => ids.includes(ser._id),
        );
        const itemsWqtyprice = items.map((item: any, index: any) => {
          const {
            categoryId,
            categoryName,
            categoryNameAr,
            departmentId,
            departmentName,
            departmentNameAr,
            departmentColor,
            employeeId,
            employeeName,
            employeeNameAr,
            employeeColor,
            resourseId,
            resourseName,
            resourseNameAr,
            resourseColor,
            contractId,
            contractName,
            contractNameAr,
            parentitem,
            note,
          } = item;
          const serv = servlist.filter((se: any) => se._id === item.itemId)[0];
          return {
            ...serv,
            categoryId,
            categoryName,
            categoryNameAr,
            departmentId,
            departmentName,
            departmentNameAr,
            departmentColor,
            employeeId,
            employeeName,
            employeeNameAr,
            employeeColor,
            resourseId,
            resourseName,
            resourseNameAr,
            resourseColor,
            contractId,
            contractName,
            contractNameAr,
            parentitem,
            index,
            itemqty: item.qty,
            note,
          };
        });
        itemsWqtyprice.sort((a: any, b: any) =>
          a.categoryNameAr > b.categoryNameAr
            ? 1
            : b.categoryNameAr > a.categoryNameAr
              ? -1
              : 0,
        );
        setItemsList(itemsWqtyprice);
      } else {
        setItemsList([]);
      }
      const relateditems =
        relateditemsData?.data?.['getContractRelatedItems']?.data || [];
      if (relateditems && relateditems.length > 0) {
        const rids = relateditems.map((it: any) => it.itemId);
        const servlist = [...rentitems, ...products, ...services].filter(
          (ser: any) => rids.includes(ser._id),
        );
        const ritemsWqtyprice = relateditems.map((item: any, index: any) => {
          const {
            categoryId,
            categoryName,
            categoryNameAr,
            departmentId,
            departmentName,
            departmentNameAr,
            departmentColor,
            employeeId,
            employeeName,
            employeeNameAr,
            employeeColor,
            resourseId,
            resourseName,
            resourseNameAr,
            resourseColor,
            contractId,
            contractName,
            contractNameAr,
            parentitem,
            note,
          } = item;
          const serv = servlist.filter((se: any) => se._id === item.itemId)[0];
          return {
            ...serv,
            categoryId,
            categoryName,
            categoryNameAr,
            departmentId,
            departmentName,
            departmentNameAr,
            departmentColor,
            employeeId,
            employeeName,
            employeeNameAr,
            employeeColor,
            resourseId,
            resourseName,
            resourseNameAr,
            resourseColor,
            contractId,
            contractName,
            contractNameAr,
            parentitem,
            index,
            itemqty: item.qty,
            note,
          };
        });
        ritemsWqtyprice.sort((a: any, b: any) =>
          a.categoryNameAr > b.categoryNameAr
            ? 1
            : b.categoryNameAr > a.categoryNameAr
              ? -1
              : 0,
        );
        setRelatedItemsList(ritemsWqtyprice);
      } else {
        setRelatedItemsList([]);
      }
    }
  }, [itemsData, relateditemsData, row]);

  useEffect(() => {
    if (opData?.data?.getInvoices?.data) {
      const { data } = opData.data.getInvoices;
      setInvoiceRows(data);
    }
  }, [opData]);

  useEffect(() => {
    if (item?._id && tasks && tasks.length > 0) {
      const opened = tasks.filter((ts: any) => ts._id === item._id)?.[0];
      setRow(opened);
    }
  }, [tasks]);

  useEffect(() => {
    if (row && row._id) {
      const custId = row.customerId;
      const resId = row.resourseId;
      if (resId) {
        const empl = resourses.filter((emp: any) => emp._id === resId)[0];
        setResovalue(empl);
      }
      if (custId) {
        const cust = customers.filter((cu: any) => cu._id === custId)[0];
        setCustvalue(cust);
      }
    }
  }, [row, customers, resourses]);

  useEffect(() => {
    if (row && row._id) {
      getItems({ variables: { opId: row._id } });
      getRelatedItems({ variables: { contractId: row._id } });
    }
  }, [row]); // Load initial data when row changes

  useEffect(() => {
    if (row && row._id) {
      // Reload invoices when date filters change (for invoice tab display)
      loadInvoices({
        variables: {
          contractId: row._id,
          start: start ? start.setHours(0, 0, 0, 0) : undefined,
          end: end ? end.setHours(23, 59, 59, 999) : undefined,
        },
      });
    }
  }, [row]); // Reload when date filters change
  const {
    translate: { words, isRTL },
    store: { user },
  }: GContextTypes = useContext(GlobalContext);

  const refresReceiptQuery = {
    refetchQueries: [
      {
        query: getReceipts,
        variables: {
          contractId: row?._id,
          start: start ? new Date(start).setHours(0, 0, 0, 0) : undefined,
          end: end ? new Date(end).setHours(23, 59, 59, 999) : undefined,
        },
      },
      {
        query: getGereralCalculation,
        variables: {
          contractId: row?._id,
          start: start ? new Date(start).setHours(0, 0, 0, 0) : undefined,
          end: end ? new Date(end).setHours(23, 59, 59, 999) : undefined,
        },
      },
      {
        query: getTasks,
        variables: {
          contractId: row?._id,
          start: mstart ? new Date(mstart).setHours(0, 0, 0, 0) : undefined,
          end: mend ? new Date(mend).setHours(23, 59, 59, 999) : undefined,
        },
      },
      { query: getTasks },
      { query: getProjects },
    ],
  };
  const refresExpensesQuery = {
    refetchQueries: [
      {
        query: getExpenses,
        variables: {
          contractId: row?._id,
          opType: 60,
          start: start ? new Date(start).setHours(0, 0, 0, 0) : undefined,
          end: end ? new Date(end).setHours(23, 59, 59, 999) : undefined,
        },
      },
      {
        query: getGereralCalculation,
        variables: {
          contractId: row?._id,
          start: start ? new Date(start).setHours(0, 0, 0, 0) : undefined,
          end: end ? new Date(end).setHours(23, 59, 59, 999) : undefined,
        },
      },
      {
        query: getTasks,
        variables: {
          contractId: row?._id,
          start: mstart ? new Date(mstart).setHours(0, 0, 0, 0) : undefined,
          end: mend ? new Date(mend).setHours(23, 59, 59, 999) : undefined,
        },
      },

      { query: getTasks },
      { query: getProjects },
    ],
  };

  const [addFinance] = useMutation(createFinance, refresReceiptQuery);

  const [addExpenses] = useMutation(createExpenses, refresExpensesQuery);

  const printData = {
    ...row,
    items: itemsList,
    ritems: relatedItemsList,
    contractTime: row?.start,
    customerName: isRTL ? row?.customerNameAr : row?.customerName,
    customerPhone: row?.customerPhone,
    hallName: isRTL ? row?.resourseNameAr : row?.resourseName,
    hallAddress: row?.address,
    calcs,
    no: row?.docNo,
    start,
    end,
    time: start,
    resovalue,
    custvalue,
    // info,
    isRTL: isRTL,
  };
  const componentRef: any = useRef();
  const handleReactPrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: `Contract #${row?.docNo}`,
    removeAfterPrint: true,
  });

  const stockRef: any = useRef();
  const handleStockReactPrint = useReactToPrint({
    content: () => stockRef.current,
    documentTitle: `Staock #${row?.docNo}`,
    removeAfterPrint: true,
  });
  const purchaseRef: any = useRef();
  const handlePurchaseReactPrint = useReactToPrint({
    content: () => purchaseRef.current,
    documentTitle: `Purchase #${row?.docNo}`,
    removeAfterPrint: true,
  });

  const template = getDefaultTemplate(printtemplates, 'stockorder');

  const toCloseTask = async (time: any) => {
    setCloseloading(true);
    const variables = {
      _id: row._id,
      time: new Date(),
    };
    await stopTask({ variables });
    setCloseloading(false);
  };
  const toStartTask = async () => {
    setCloseloading(true);
    await startTask({
      variables: {
        _id: row._id,
      },
    });
    setCloseloading(false);
  };

  const resetAllForms = () => {
    setValue(0);
  };

  const onCloseForm = () => {
    resetAllForms();
    onClose();
  };

  const handleConfirmProceed = () => {
    setConfirmDialogOpen(false);
    setCanProceedWithAdd(true);
    // Execute the pending add action
    if (pendingExecute) {
      pendingExecute();
    }
    // Reset the flag after execution
    setTimeout(() => {
      setCanProceedWithAdd(false);
      setPendingExecute(null);
    }, 100);
  };

  const handleConfirmCancel = () => {
    setConfirmDialogOpen(false);
    setPendingExecute(null);
  };
  const title = `${tempwords?.task} : ${row?.title}`;
  const renderMain = () => {
    return (
      <MainCustomer
        isRTL={isRTL}
        words={words}
        theme={theme}
        name="contractId"
        value={row}
        id={row?._id}
        width={width}
        height={height}
        start={isTime ? start : null}
        end={isTime ? end : null}
        setCalcs={setCalcs}
      ></MainCustomer>
    );
  };
  const renderEvent = () => {
    return (
      <EventsCustomer
        isRTL={isRTL}
        words={words}
        theme={theme}
        id={row?._id}
        name="contractId"
        width={width}
        height={height}
        start={isTime ? start : null}
        end={isTime ? end : null}
        mstart={mstart}
        mend={mend}
        value={row}
        company={company}
        tempoptions={tempoptions}
      ></EventsCustomer>
    );
  };
  const renderEventItems = () => {
    return (
      <EventsItemsCustomer
        isRTL={isRTL}
        words={words}
        theme={theme}
        name="contractId"
        id={row?._id}
        width={width}
        height={height}
        start={isTime ? start : null}
        end={isTime ? end : null}
        tempoptions={tempoptions}
      ></EventsItemsCustomer>
    );
  };
  const renderInvoice = () => {
    return (
      <InvoicesCustomer
        isRTL={isRTL}
        words={words}
        theme={theme}
        name="contractId"
        id={row?._id}
        width={width}
        height={height}
        start={isTime ? start : null}
        end={isTime ? end : null}
        mstart={mstart}
        mend={mend}
        value={row}
        company={company}
        tempoptions={tempoptions}
      ></InvoicesCustomer>
    );
  };
  const renderInvoicesItems = () => {
    return (
      <InvoicesItemsCustomer
        isRTL={isRTL}
        words={words}
        theme={theme}
        name="contractId"
        id={row?._id}
        width={width}
        height={height}
        start={isTime ? start : null}
        end={isTime ? end : null}
        tempoptions={tempoptions}
      ></InvoicesItemsCustomer>
    );
  };
  const renderReceipt = () => {
    return (
      <ReceiptCustomer
        isRTL={isRTL}
        words={words}
        theme={theme}
        name="contractId"
        id={row?._id}
        width={width}
        height={height}
        start={isTime ? start : null}
        end={isTime ? end : null}
        mstart={mstart}
        mend={mend}
        value={row}
        company={company}
      ></ReceiptCustomer>
    );
  };

  const renderPurchase = () => {
    return (
      <InvoicesSupplier
        isRTL={isRTL}
        words={words}
        theme={theme}
        name="contractId"
        id={row?._id}
        width={width}
        height={height}
        start={isTime ? start : null}
        end={isTime ? end : null}
        mstart={mstart}
        mend={mend}
        value={row}
        company={company}
        tempoptions={tempoptions}
      ></InvoicesSupplier>
    );
  };
  const renderPurchaseOrder = () => {
    return (
      <OrdersSupplier
        isRTL={isRTL}
        words={words}
        theme={theme}
        name="contractId"
        id={row?._id}
        width={width}
        height={height}
        start={isTime ? start : null}
        end={isTime ? end : null}
        mstart={mstart}
        mend={mend}
        value={row}
        company={company}
        tempoptions={tempoptions}
      ></OrdersSupplier>
    );
  };
  const renderPayment = () => {
    return (
      <PaymentSupplier
        isRTL={isRTL}
        words={words}
        theme={theme}
        name="contractId"
        id={row?._id}
        width={width}
        height={height}
        start={isTime ? start : null}
        end={isTime ? end : null}
        mstart={mstart}
        mend={mend}
        value={row}
        company={company}
      ></PaymentSupplier>
    );
  };
  const renderExpense = () => {
    return (
      <ExpensesCustomer
        isRTL={isRTL}
        words={words}
        theme={theme}
        name="contractId"
        id={row?._id}
        width={width}
        height={height}
        start={isTime ? start : null}
        end={isTime ? end : null}
        mstart={mstart}
        mend={mend}
        value={row}
        company={company}
        tempoptions={tempoptions}
        tempwords={tempwords}
      ></ExpensesCustomer>
    );
  };
  const renderExpenseItems = () => {
    return (
      <ExpensesItemsCustomer
        isRTL={isRTL}
        words={words}
        theme={theme}
        name="contractId"
        id={row?._id}
        width={width}
        height={height}
        start={isTime ? start : null}
        end={isTime ? end : null}
        tempoptions={tempoptions}
      ></ExpensesItemsCustomer>
    );
  };
  const renderExpenseProd = () => {
    return (
      <ExpensesProdCustomer
        isRTL={isRTL}
        words={words}
        theme={theme}
        name="contractId"
        id={row?._id}
        width={width}
        height={height}
        start={isTime ? start : null}
        end={isTime ? end : null}
        mstart={mstart}
        mend={mend}
        value={row}
        company={company}
        tempoptions={tempoptions}
        tempwords={tempwords}
      ></ExpensesProdCustomer>
    );
  };
  const renderKaids = () => {
    return (
      <KaidsCustomer
        isRTL={isRTL}
        words={words}
        theme={theme}
        name="contractId"
        id={row?._id}
        width={width}
        height={height}
        start={isTime ? start : null}
        end={isTime ? end : null}
        mstart={mstart}
        mend={mend}
        tempoptions={tempoptions}
      ></KaidsCustomer>
    );
  };
  const renderReminder = () => {
    return (
      <ReminderCustomer
        isRTL={isRTL}
        words={words}
        theme={theme}
        name="contractId"
        value={row}
        id={row?._id}
        width={width}
        height={height}
        start={isTime ? start : null}
        end={isTime ? end : null}
        mstart={mstart}
        mend={mend}
        tempoptions={tempoptions}
      ></ReminderCustomer>
    );
  };
  const filterTabs = taskManamentTabs.filter((item: any) => !item.hide);

  return (
    <PopupLayout
      isRTL={isRTL}
      open={open}
      onClose={onCloseForm}
      title={title}
      onSubmit={() => null}
      theme={theme}
      alrt={{}}
      maxWidth={'xl'}
      print={
        !isNew && [4, 5, 7, 8].includes(company?.tempId)
          ? handleReactPrint
          : undefined
      }
      mb={0}
      mt={0}
      onlyclose
      preventclose
      canceltitle={isRTL ? 'اغلاق' : 'close'}
    >
      <Box>
        <Box display="flex" style={{ backgroundColor: '#fff', height: 50 }}>
          <Box display="flex" style={{ padding: 7 }}>
            <FormControlLabel
              control={
                <Checkbox
                  style={{ padding: 7 }}
                  checked={isTime}
                  onChange={() => {
                    setIsTime(!isTime);
                  }}
                  color="primary"
                />
              }
              label={
                <Typography
                  style={{
                    color: theme.palette.primary.main,
                    fontWeight: 'bold',
                  }}
                >
                  {isRTL ? 'تفعيل التاريخ' : 'Activate Date'}
                </Typography>
              }
              style={{ fontSize: 14 }}
            />
          </Box>
          <Box
            style={{
              opacity: !isTime ? 0.5 : undefined,
              pointerEvents: !isTime ? 'none' : undefined,
            }}
          >
            <DateNavigatorReports
              setStart={setStart}
              setEnd={setEnd}
              currentDate={currentDate}
              currentDateChange={currentDateChange}
              currentViewName={currentViewName}
              currentViewNameChange={currentViewNameChange}
              endDate={endDate}
              endDateChange={endDateChange}
              views={[1, 7, 30, 365, 1000]}
              isRTL={isRTL}
              words={words}
              theme={theme}
            ></DateNavigatorReports>
          </Box>
        </Box>
        <Box style={{ display: 'flex', marginTop: 0 }}>
          <Grid container spacing={0} style={{ width: width - 300 }}>
            <Grid item xs={12}>
              <Box
                style={{
                  backgroundColor: '#f5f5f5',
                }}
              >
                <Box display="flex" style={{}}></Box>
                {row && (
                  <Paper
                    elevation={0}
                    style={{ marginBottom: 10, backgroundColor: '#f5f5f5' }}
                  >
                    {filterTabs.map((item: any, index: any) => {
                      return (
                        <TabPanel value={value} index={index}>
                          {item.ref === 'main' && renderMain()}
                          {item.ref === 'events' && renderEvent()}
                          {item.ref === 'eventsitems' && renderEventItems()}
                          {item.ref === 'invoices' && renderInvoice()}
                          {item.ref === 'invoicesitems' &&
                            renderInvoicesItems()}
                          {item.ref === 'receipts' && renderReceipt()}
                          {item.ref === 'purchaseorders' &&
                            renderPurchaseOrder()}
                          {item.ref === 'purchases' && renderPurchase()}
                          {item.ref === 'payments' && renderPayment()}
                          {item.ref === 'expenses' && renderExpense()}
                          {item.ref === 'expensesitems' && renderExpenseItems()}
                          {item.ref === 'expensesprod' && renderExpenseProd()}
                          {item.ref === 'entries' && renderKaids()}
                          {item.ref === 'reminders' && renderReminder()}
                        </TabPanel>
                      );
                    })}
                  </Paper>
                )}
              </Box>
            </Grid>
          </Grid>
          {row && (
            <Box style={{ width: 200 }}>
              <Box>
                <Tabs
                  orientation="vertical"
                  value={value}
                  onChange={handleChange}
                  aria-label="items"
                  className={classes.tabs}
                  variant="fullWidth"
                  TabIndicatorProps={{ style: { width: 3 } }}
                  textColor="primary"
                  centered
                >
                  {filterTabs.map((item: any) => {
                    if (item.hide) {
                      return <div></div>;
                    }
                    return (
                      <Tab
                        style={{
                          backgroundColor:
                            value === item.id ? '#f5f5f5' : undefined,
                        }}
                        label={
                          <Typography
                            style={{ fontWeight: 'bold', fontSize: 13 }}
                          >
                            {isRTL ? item.nameAr : item.name}
                          </Typography>
                        }
                        {...a11yProps(item.id)}
                      />
                    );
                  })}
                </Tabs>
              </Box>

              {/* Approval status banner */}
              {!isNew && !isTaskApproved && (
                <Box
                  style={{
                    backgroundColor: '#fff3e0',
                    border: '1px solid #ff9800',
                    borderRadius: 8,
                    padding: 10,
                    margin: 10,
                    textAlign: 'center',
                  }}
                >
                  <Typography
                    style={{
                      color: '#e65100',
                      fontWeight: 'bold',
                      fontSize: 13,
                    }}
                  >
                    {isRTL
                      ? 'العقد بانتظار الاعتماد - الإجراءات معلقة'
                      : 'Task pending approval - Actions are on hold'}
                  </Typography>
                </Box>
              )}

              {userroles?.sales?.add && (
                <Box
                  style={{ paddingLeft: 10, paddingRight: 10, marginTop: 30 }}
                >
                  <Button
                    variant="contained"
                    fullWidth
                    color="primary"
                    disabled={!isTaskApproved}
                    onClick={() => {
                      // Check if there are existing invoices and show confirmation dialog
                      if (invoiceRows.length > 0 && !canProceedWithAdd) {
                        setPendingExecute(() => () => setOpenInvoice(true));
                        setConfirmDialogOpen(true);
                      } else {
                        setOpenInvoice(true);
                      }
                    }}
                    style={{ backgroundColor: colors.blue[500] }}
                  >
                    <Typography style={{ fontSize: 14 }}>
                      {words.newInvoice}
                    </Typography>
                  </Button>
                </Box>
              )}
              {userroles?.sales?.add && (
                <Box
                  style={{ paddingLeft: 10, paddingRight: 10, marginTop: 10 }}
                >
                  <Button
                    variant="contained"
                    fullWidth
                    color="primary"
                    disabled={!isTaskApproved}
                    style={{ backgroundColor: colors.blue[500] }}
                    onClick={() => setOpenReceipt(true)}
                  >
                    <Typography style={{ fontSize: 14 }}>
                      {isRTL ? 'سند قبض' : 'Receipt'}
                    </Typography>
                  </Button>
                </Box>
              )}
              {userroles?.finance?.add && (
                <Box
                  style={{ paddingLeft: 10, paddingRight: 10, marginTop: 10 }}
                >
                  <Button
                    variant="contained"
                    fullWidth
                    color="primary"
                    disabled={!isTaskApproved}
                    onClick={() => setOpenExpenses(true)}
                    style={{ backgroundColor: colors.orange[500] }}
                  >
                    <Typography style={{ fontSize: 14 }}>
                      {isRTL ? 'مصروف' : 'Expenses'}
                    </Typography>
                  </Button>
                </Box>
              )}
              {userroles?.purchase?.add && (
                <Box
                  style={{ paddingLeft: 10, paddingRight: 10, marginTop: 10 }}
                >
                  <Button
                    variant="contained"
                    fullWidth
                    color="primary"
                    disabled={!isTaskApproved}
                    onClick={() => setOpenOrder(true)}
                    style={{ backgroundColor: colors.deepPurple[500] }}
                  >
                    <Typography style={{ fontSize: 14 }}>
                      {isRTL ? 'طلب شراء' : 'Purchase Order'}
                    </Typography>
                  </Button>
                </Box>
              )}
              <Box style={{ paddingLeft: 10, paddingRight: 10, marginTop: 10 }}>
                <PrintStockOrder
                  company={company}
                  printData={printData}
                  types={[4]}
                  template={template}
                  componentRef={stockRef}
                  handleReactPrint={handleStockReactPrint}
                  no={row?.docNo}
                  element="stockorder"
                  elementid="stocklist"
                  isRTL={isRTL}
                  isNew={isNew}
                  title={isRTL ? 'تجهيزات الحفل' : 'Stock List'}
                  approvalStatus={row?.approvalStatus}
                ></PrintStockOrder>
              </Box>
              <Box style={{ paddingLeft: 10, paddingRight: 10, marginTop: 10 }}>
                <PrintStockOrder
                  company={company}
                  printData={printData}
                  types={[1, 2]}
                  template={template}
                  componentRef={purchaseRef}
                  handleReactPrint={handlePurchaseReactPrint}
                  no={row?.docNo}
                  element="stockorder"
                  elementid="purchaselist"
                  isRTL={isRTL}
                  isNew={isNew}
                  title={isRTL ? 'المشتريات' : 'Purchase List'}
                  approvalStatus={row?.approvalStatus}
                ></PrintStockOrder>
              </Box>
              <Box style={{ marginTop: 10 }}>
                {userroles?.operations?.admin && (
                  <Box
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      margin: 10,
                    }}
                  >
                    <Button
                      variant="contained"
                      color="primary"
                      fullWidth
                      disabled={closeloading || row?.isClosed}
                      onClick={toCloseTask}
                      style={{ height: 30 }}
                    >
                      <Typography style={{ fontSize: 14 }}>
                        {isRTL ? 'الغاء العقد' : 'Disactivate'}
                      </Typography>
                    </Button>
                    {userroles?.operations?.admin && (
                      <Button
                        variant="contained"
                        fullWidth
                        color="primary"
                        disabled={closeloading || !row?.isClosed}
                        onClick={toStartTask}
                        style={{ height: 30 }}
                      >
                        <Typography style={{ fontSize: 14 }}>
                          {isRTL ? 'تفعيل' : 'Activate'}
                        </Typography>
                      </Button>
                    )}
                  </Box>
                )}
              </Box>
            </Box>
          )}
          {row && (
            <PopupTaskInvoice
              open={openInvoice}
              onClose={() => setOpenInvoice(false)}
              task={row}
              customers={customers}
              services={services}
              resourses={resourses}
              employees={employees}
              departments={departments}
              company={company}
              theme={theme}
              mstart={start}
              mend={end}
            ></PopupTaskInvoice>
          )}
          {row && (
            <PopupReceipt
              open={openReceipt}
              onClose={() => setOpenReceipt(false)}
              task={row}
              isNew={true}
              addAction={addFinance}
              editAction={() => null}
              theme={theme}
              company={company}
              name="customerId"
              value={custvalue}
            ></PopupReceipt>
          )}
          {row && (
            <PopupExpensesDoc
              open={openExpenses}
              onClose={() => setOpenExpenses(false)}
              task={row}
              isNew={true}
              addAction={addExpenses}
              editAction={() => null}
              resourses={resourses}
              employees={employees}
              departments={departments}
              servicesproducts={expenseItems}
              theme={theme}
              company={company}
              name="contractId"
              value={row}
            ></PopupExpensesDoc>
          )}
          {row && (
            <PopupPurchaseOrder
              open={openOrder}
              onClose={() => setOpenOrder(false)}
              task={row}
              isNew={true}
              addAction={addPurchaseOrder}
              editAction={() => null}
              resourses={resourses}
              employees={employees}
              departments={departments}
              servicesproducts={products}
              theme={theme}
              company={company}
              name="contractId"
              value={row}
              itemstype={'task'}
              items={relatedItemsList}
            ></PopupPurchaseOrder>
          )}
          <Box>
            <div style={{ display: 'none' }}>
              <ContractPrint
                company={company}
                user={user}
                printData={printData}
                ref={componentRef}
              />
            </div>
          </Box>
          <Dialog
            open={confirmDialogOpen}
            onClose={handleConfirmCancel}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            style={{ direction: isRTL ? 'rtl' : 'ltr' }}
          >
            <DialogTitle id="alert-dialog-title">
              {isRTL ? 'تحذير' : 'Warning'}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                {isRTL
                  ? 'يوجد فاتورة مسجلة بالفعل لهذا العقد. هل تريد المتابعة وإضافة فاتورة أخرى؟'
                  : 'You already have an invoice for this contract. Do you want to proceed and add another invoice?'}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleConfirmCancel} color="primary">
                {isRTL ? 'إلغاء' : 'Cancel'}
              </Button>
              <Button
                onClick={handleConfirmProceed}
                color="primary"
                autoFocus
                variant="contained"
              >
                {isRTL ? 'متابعة' : 'Proceed'}
              </Button>
            </DialogActions>
          </Dialog>
        </Box>
      </Box>
    </PopupLayout>
  );
};

export default PopupTaskView;
